import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	root: {
		background: theme.palette.background.light,
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(10),
		paddingBottom: theme.spacing(10),
		paddingTop: theme.spacing(10)
	}
}));

export default styles;
